export default __webpack_public_path__ + "36b7c82a9f23c246ff1376ffe7c00eb0.png";